export const fakeSort = {
    sorter: () => {
        return false;
    },
    sortDirections: ['descend','ascend']
};
